<template>
  <div class="profile-page">
    <div class="container-fuild">
      <card shadow class="pt-5 mt-5" no-body type="dark">
        <div class="container mt-lg-3">
          <div class="row">
            <div class="col-5 col-lg-3 order-lg-1">
              <div class="card-profile-image">
                <a href="#">
                  <img
                    v-lazy="'/img/theme/team-4-800x800.jpg'"
                    style="width: 160px; height: 160px;"
                    class="rounded-circle img-fluid"
                    alt="Jane Doe"
                  />
                </a>
              </div>
            </div>
            <div class="col-7 col-lg-5 order-lg-2">
              <div class="card-profile-image">
                <p class="h2 mt-4">Jane Doe</p>
                <p class="h6 mt-1 d-flex align-items-center">
                  <i class="ni ni-pin-3"></i>
                  <span class="pl-2">Cape Coast, Ghana</span>
                </p>
                <p class="h6 mt-1 d-flex align-items-center">
                  <i class="ni ni-building"></i>
                  <span class="pl-2">Not registered in any hostel yet</span>
                </p>
              </div>
            </div>
            <div class="mt-3 mt-md-0 col-12 col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
              <!-- <div class="card-profile-actions py-4 mt-lg-0">
                <base-button type="info" size="sm" class="mr-4">Connect</base-button>
                <base-button type="default" size="sm" class="float-right">Message</base-button>
              </div>-->
              <card type="darker">
                <div class="progress-wrapper">
                  <div class="progress-info">
                    <div class="progress-label">
                      <span class="text-white">Profile Completion</span>
                    </div>
                    <div class="progress-percentage">
                      <span>60%</span>
                    </div>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-bar bg-default"
                      role="progressbar"
                      aria-valuenow="60"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style="width: 60%;"
                    ></div>
                  </div>
                </div>
                <div>
                  <!-- <p class="h6 mt-1 d-flex align-items-center">
                    <i class="ni ni-laptop"></i>
                    <span class="pl-2">Registered Devices</span>
                  </p>-->
                  <p class="btn btn-default btn-sm d-flex align-items-center">
                    <i class="ni ni-laptop"></i>
                    <span class="pl-2">Registered Devices</span>
                    <!-- <span class="badge badge-secondary">0</span> -->
                    <a href="/devices" class="badge badge-secondary stretched-link">0</a>
                  </p>

                  <!-- <p class="h6 mt-1 d-flex align-items-center">
                    <i class="ni ni-building"></i>
                    <span class="pl-2">Not registered in any hostel yet</span>
                  </p>-->
                </div>
              </card>
            </div>
          </div>
        </div>
      </card>
      <card shadow class="pt-5 mt-5 rounded-0" no-body>
        <div class="container">
          <div class="row">
            <div class="col-sm-8">
              <about></about>
            </div>
            <div class="col-sm-4">
              <contact></contact>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import About from "./components/ProfileComponents/About";
import Contact from "./components/ProfileComponents/Contact";
export default {
  name: "profile-page",
  components: {
    About,
    Contact
  }
};
</script>
<style>
</style>
